import moment from "moment";
import Key from "../../clientVariables.json";

function splitBySpecialCharacters(input) {
    const specialCharRegex = /[^a-zA-Z0-9\s]+/;
    const parts = input.split(specialCharRegex);
    const cleanedParts = parts
      .map((part) => part.trim())
      .filter((part) => part !== "");
    return cleanedParts;
  }
  
  function getMappedDates(dateOption) {
    const today = new Date();
    let startdate;
  
    if (dateOption == "1") {
      startdate = moment(today)
        .subtract(1, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (dateOption == "2") {
      startdate = moment(today)
        .subtract(7, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else if (dateOption == "3") {
      startdate = moment(today)
        .subtract(30, "d")
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss[Z]");
    } else {
      startdate = null;
    }
  
    return startdate ? `${startdate} TO NOW` : null;
  }
  
  const removeItems = [
    "skill",
    "technology",
    "developer",
    "programmer",
    "architect",
    "designer",
    "consultant",
    "administrator",
    "coach",
    "lead",
    "manager",
    "master",
    "specalist",
    "modeler",
    "director",
    "hacker",
    "engineer",
    "analyst",
    "dba",
    "tester",
    "senior",
    "senior.",
    "sr",
    "junior",
    "junior.",
    "jr",
    "sr.",
    "jr.",
    "knowledge",
    "or",
    "with",
    "to",
    "and",
    "front",
    "end",
    "back",
    "full",
    "stack",
    "full stack",
  ];
  
  function processSearchTitle(title) {
    const wordRegex = /[^\W\d_]+/g;
    const words = title.match(wordRegex);
    // console.log('processSearchTitle words', words);
  
    if (words) {
      const filteredWords = words.filter(
        (word) => isNaN(word) && !removeItems.includes(word.toLowerCase())
      );
      const splittingSpecialCharacter = splitBySpecialCharacters(title);
      // console.log('processSearchTitle splittingSpecialCharacter', splittingSpecialCharacter);
  
      const finalTitleWords = filteredWords.concat(splittingSpecialCharacter);
      //  .map(word => `"${word}"`)
      //  .join(" OR ");
      const finalFilter = finalTitleWords
        .filter((word) => !removeItems.includes(word.toLowerCase()))
        .map((word) => `"${word}"`)
        .join(" OR ");
      // console.log('processSearchTitle finalTitleWords', finalTitleWords, finalFilter);
  
      return finalFilter;
    } else {
      return title;
    }
  }
  
  function processSearchTitleV1(title) {
    const wordRegex = /[^\W\d_]+/g;
    const words = title.match(wordRegex);
    // console.log('processSearchTitle words', words);
  
    if (words) {
      // const filteredWords = words.filter(
      //   (word) => isNaN(word) && !removeItems.includes(word.toLowerCase())
      // );
      const splittingSpecialCharacter = splitBySpecialCharacters(title);
      // console.log('processSearchTitle splittingSpecialCharacter', splittingSpecialCharacter);
  
      // const finalTitleWords = filteredWords.concat(splittingSpecialCharacter)
      //  .map(word => `"${word}"`)
      //  .join(" OR ");
      const finalFilter = splittingSpecialCharacter
        .map((word) => `"${word}"`)
        .join(" OR ");
      // console.log('processSearchTitle finalTitleWords', finalTitleWords, finalFilter);
  
      return finalFilter;
    } else {
      return title;
    }
  }

export const jobsBuildFacetQuery = (
    filterParams = {},
    searchParams = {},
    paginationParams = {}
    // facet_counts
  ) => {
    console.log("searchParams----------", searchParams)
    const { start, rows } = paginationParams || {};
    // const solrBaseUrl = `${Key.Solr_url}/${Key.solrJobs_collection}/select?defType=edismaxq=`;
    const solrBaseUrl = `${Key.solr}/${Key.candidate_jobs_solr}/select?defType=edismax`;
    // console.log("searchParams11", searchParams);
  
    let query = "";
    let searchQuery = "";
    let filterQuery = "";
    let filterQueryList = [];
    const jobTypeID = [];
    const visaTypeID = [];
    const stateID = [];
    const cityID = [];
  

    if (
      filterParams?.city &&
      filterParams.city !== "*:*" &&
      filterParams.city !== ""
    ) {
      cityID.push(...filterParams.city?.split(" OR "));
    }
  
    // if (searchParams?.title) {
    //     console.log("searchParams?.title-------------", searchParams?.title)
    //   if (
    //     // searchParams?.searchStateFrom === "dashboard_state_map"
    //     false
    //   ) {
    //     // console.log(searchParams?.title);
  
    //     query += `&q=title:(${searchParams?.title})&qf=title^10&q.op=OR`;
    //   } else {
    //     const searchText = processSearchTitleV1(searchParams.title); // title:(Full Stack Python Developer)&defType=edismax&qf=title^10 description^2 skills^5
    //     const searchText2 = processSearchTitle(searchParams.title);

    //     console.log("searchText2------------", searchText2);
  
    //     if (searchParams.title.toLowerCase().includes("c++")) {
    //       // query += `&q=title:("${searchParams?.title}" OR "c++")&qf=title^10&q.op=OR`;
    //       filterQueryList.push(`jobtitle:("${searchParams?.title}" OR "c++")`);
    //     } else if (searchParams?.title.toLowerCase().includes("j2ee")) {
    //       // query += `&q=title:("${searchParams?.title}" OR j2ee)&qf=title^10&q.op=OR`;
    //       filterQueryList.push(`jobtitle:("${searchParams?.title}" OR j2ee)`);
    //     }
    //     // else if(searchParams?.title.toLowerCase().includes("c#")) {
    //     //   query += `&q=title:("${searchParams?.title}" OR "c#")&qf=title^10&q.op=OR`;
    //     // }
    //     else {
    //       // query += `&q=title:(${searchText2})&qf=title^10&q.op=OR`;
    //       filterQueryList.push(`jobtitle:(${searchText2})`);
    //     }
    //   }
    // } else {
    //   // query +=`&q=*:*`;
    //   // query +=`&q=`;
    // }

        if (searchParams?.title) {
          // query += `&q=title:(${searchText2})&qf=title^10&q.op=OR`;
          filterQueryList.push(`jobtitle:(${searchParams?.title})`);
        }

    if(searchParams.location) {
        filterQueryList.push(`location:${searchParams.location}`);
    }

    if(searchParams.jobtype_name) {
        filterQueryList.push(`jobtype_name:${searchParams.jobtype_name}`);
    }
    
    if(searchParams.filter_query) {
        const filterQuery = searchParams.filter_query;
        for(const filter of filterQuery) {
            filterQueryList.push(filter);
        }
    }
    // if (searchParams?.id) {
    //   const cleanedId = searchParams.id.replace("#", "");
    //   filterQueryList.push(`id:(${cleanedId})`);
    // }
    // if (searchParams?.email) {
    //   const escapedEmail = searchParams.email.replace(
    //     /([+\-&|!(){}\[\]^"~*?:\\/])/g,
    //     "\\$1"
    //   );
    //   filterQueryList.push(`contactemail:("${escapedEmail}")`);
    // }
 
    if (searchParams?.company_name) {
      filterQueryList.push(`company_name:(${searchParams.company_name})`);
    }

    if(searchParams?.posted_date) {
        filterQueryList.push(`posted_date:(${searchParams.posted_date})`);
    }


  
    // query += `&facet=true&facet.pivot=state_id,city_id&facet.field=state_id&facet.field=jobtype_id&facet.field=workpermit&facet.field=qualifications&facet.field=workmode&facet.field=map_enable&facet.mincount=1&facet.sort=count`;
  
    const finalQuery = `${
      filterQueryList?.length > 0 ? `&q=(${filterQueryList.join(" AND ")})` : ""
    }&q.op=AND${searchQuery}${query}${filterQuery || ""}`;
    return `${solrBaseUrl}${finalQuery}&rows=${rows || 10}&start=${
      start || 0
    }&sort=posted_date desc&wt=json`;
  };
  